import { getTileQuestionsAnswers } from '../answers.api';
import { TileQuestionsAnswers } from '../answers.types';

export const getFastBrainTileQuestionsAnswers = async (
	clientId: string | number
): Promise<TileQuestionsAnswers> => {
	return getTileQuestionsAnswers(clientId, 'fast_brain');
};
